import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

const convertSortFieldsFromV2 = {
  fullName: 'name_first',
  username: 'username',
  email: 'email',
  status: 'is_active',
  lastSeen: 'last_seen',
};

const exportUsersFn = ({ sorting, searchValue, userStatus, locationIds }) => {
  const orderBy = sorting.id ? sorting.id : undefined;
  const direction = !sorting.id ? undefined : sorting.desc ? 'desc' : 'asc';

  const params = {
    sort: {
      field: convertSortFieldsFromV2[orderBy],
      type: direction,
    },
    filter: {
      search: searchValue || undefined,
      locationId: locationIds,
      status: userStatus !== 'all' ? userStatus : undefined,
      permission: ['dashboardAccess', 'readonlyAccess'],
      excludeCurrentUser: 0,
      withoutWaitesUsers: 1,
    },
  };

  return apiClient.get(`${APP_SSO_URL}api/user/export-users-v2`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

export const useExportUsersMutation = () => {
  return useMutation({
    mutationFn: exportUsersFn,
  });
};
